import React from "react";
import _ from "underscore";
import $ from "jquery";
import PropTypes from "prop-types";
import AppleBannerHelpers from "helpers/apple-banner-helpers";
import { browserPropType } from "components/propTypes";
import AtomHed from "components/source/atoms/atom-hed";
import AtomDek from "components/source/atoms/atom-dek";
import ClosableModal from "components/source/shared/closable-modal";
import GridFilterMultiPanelModal from "components/source/new_taxonomy/grid-filter-multi-panel-modal";
import GridTopFiltersZip from "components/source/new_taxonomy/grid-top-filters-zip";

const modalName = "grid-top-filters-zip-modal";

class GridTopFiltersZipModal extends React.Component {
  static propTypes = {
    browser: browserPropType,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onRequestClose: PropTypes.func,
    onSubmit: PropTypes.func,
    workingFilters: PropTypes.object,
  };

  static modalName = modalName;

  state = {
    bottomPosition: this.appleBannerHeight(),
  };

  componentDidMount() {
    $(window).resize(_.bind(this.setButtonPosition, this));
  }

  componentWillUnmount() {
    $(window).off("resize", this.setButtonPosition);
  }

  appleBannerHeight() {
    return `${AppleBannerHelpers.appleBannerHeight()}px`;
  }

  setButtonPosition() {
    this.setState({ bottomPosition: this.appleBannerHeight() });
  }

  render() {
    const mobileStyles = {
      content: {
        bottom: this.state.bottomPosition,
      },
    };
    const styles = this.props.browser.isMobileViewport ? mobileStyles : {};

    return (
      <ClosableModal
        additionalStyles={styles}
        isOpen={this.props.displayedModal === modalName}
        optionalClass={`multi-panel-modal ${GridFilterMultiPanelModal.filterModalName} ${modalName} grid-superbar`}
        onRequestClose={this.props.onRequestClose}>
        <AtomHed text="Where will we be shipping?" />
        <AtomDek
          text="We'll show you available styles in that location."
          mobileText="We'll show you available styles in that location."
        />
        <GridTopFiltersZip onSubmit={this.props.onSubmit} workingFilters={this.props.workingFilters} />
      </ClosableModal>
    );
  }
}

export default GridTopFiltersZipModal;
